module.exports = __webpack_public_path__ + "img/illustration-laptop-desktop.24117652.svg";